// extracted by mini-css-extract-plugin
module.exports = {"kensaOrder_Detail":"OrderDetail_kensaOrder_Detail__syCRE","kensaOrder_Footer":"OrderDetail_kensaOrder_Footer__2_7i6"};